// extracted by mini-css-extract-plugin
export var wrapper = "lectures-module--wrapper--1eE92";